import { Checkbox } from '@trackman/web-shared-components';
import React from 'react';
import styled, { css } from 'styled-components';
import { darkgrey, grey } from 'styles/Colors';
import { ReactComponent as CloseIcon } from 'images/close.svg';

export const ConfiguratorWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 300px;
  height: 100%;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.14);
  background-color: #fff;
  z-index: 999;
`;

export const Title = styled.div`
  text-align: center;
  font-family: 'Oswald';
  font-size: 22px;
  color: ${darkgrey};
  padding: 25px 0;
  text-transform: uppercase;
  position: relative;
`;

export const StyledCheckbox = styled((props) => <Checkbox {...props} />)<{ disabled?: boolean }>`
  &&& {
    border: none;
    border-top: 1px solid #e0e0e0;
    border-radius: 0;
    justify-content: flex-start;
    .MuiTypography-root {
      font-weight: 400;
    }
    ${(props) =>
      props.disabled &&
      css`
        rect {
          fill: ${grey};
        }
      `}
  }
`;

export const ColumnList = styled.div`
  height: calc(100% - 83px);
  overflow: auto;
`;

export const StyledCloseIcon = styled((props) => <CloseIcon {...props} />)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 24px;
  padding: 8px;
  width: 32px;
  height: 32px;

  &:hover {
    cursor: pointer;
  }
`;
